// The queue says nothing back when a phone adds to it, so the confirmation waits for the song to show
// up in the queue the television publishes. An older television publishes none, so it says "sent".
export const QUEUE_CONFIRM_MS = 3000;

export function createQueueConfirmations(flash: (message: string) => void, timeoutMs = QUEUE_CONFIRM_MS) {
  const pending = new Map<string, ReturnType<typeof setTimeout>>();

  const settle = (id: string) => {
    clearTimeout(pending.get(id));
    pending.delete(id);
  };

  return {
    isPending: (id: string) => pending.has(id),

    sent(id: string, title: string) {
      settle(id);
      pending.set(
        id,
        setTimeout(() => {
          pending.delete(id);
          flash(`Sent "${title}" to the queue`);
        }, timeoutMs),
      );
    },

    failed(id: string, title: string) {
      if (!pending.has(id)) return;
      settle(id);
      flash(`The TV did not queue "${title}"`);
    },

    queueChanged(queue: Array<{ id: string; title: string }>) {
      queue.forEach((entry, index) => {
        if (!pending.has(entry.id)) return;
        settle(entry.id);
        flash(`"${entry.title}" is #${index + 1} in the queue`);
      });
    },

    dispose() {
      pending.forEach((timer) => clearTimeout(timer));
      pending.clear();
    },
  };
}
